"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PageVitalsObserver_1 = require("./PageVitalsObserver");
var includedWebVitals = ['Next.js-hydration', 'FCP', 'TTFB'];
/**
 *
 * @param param0
 */
var useCoreWebvitals = function (_a) {
    var updateMetricData = _a.updateMetricData, recordMetric = _a.recordMetric, includeWebVitals = _a.includeWebVitals, customTimingLabel = _a.customTimingLabel;
    var webVitals = (0, react_1.useRef)({});
    var hasFCP = (0, react_1.useRef)(false);
    var hasRecordPageLoad = (0, react_1.useRef)(false);
    var hasTrackPageLoad = (0, react_1.useRef)(false);
    var timings = (0, react_1.useRef)({ start: undefined, duration: undefined });
    var didAddTimmingBeforeFCP = (0, react_1.useRef)(false);
    /**
     *
     */
    var recordPageLoad = (0, react_1.useCallback)(function (url, result, data, eventName, timerID) {
        var _a;
        if (result === void 0) { result = 'success'; }
        if (timerID === void 0) { timerID = 'mainContent'; }
        hasRecordPageLoad.current = true;
        // cast types
        var fcp = webVitals.current['FCP'] || 0;
        webVitals.current['Next-js-hydration'] = webVitals.current['Next.js-hydration'];
        var pageTimings = __assign((_a = {}, _a[timerID] = didAddTimmingBeforeFCP.current
            ? Math.round(fcp - timings.current.duration)
            : Math.round(timings.current.duration + fcp), _a), webVitals.current);
        delete pageTimings['Next.js-hydration'];
        updateMetricData(__assign({}, (Object.keys(webVitals.current).length > 0 && {
            pageTimings: pageTimings,
            serverDuration: fcp
        })));
        recordMetric(url, result, data, eventName);
        webVitals.current = {};
        timings.current = { start: undefined, duration: undefined };
        didAddTimmingBeforeFCP.current = false;
    }, [updateMetricData, recordMetric]);
    /**
     * This function completes a page load and records the metric if we have capture the FCP metric.
     */
    var trackPageLoad = (0, react_1.useCallback)(function (url, result, data, eventName, timerID) {
        if (result === void 0) { result = 'success'; }
        if (timerID === void 0) { timerID = 'mainContent'; }
        if (DD_RUM) {
            // Add custom timing as soon as the page has finished loading
            DD_RUM.addTiming(customTimingLabel);
        }
        hasTrackPageLoad.current = true;
        if (hasFCP.current) {
            if (timings.current.start)
                timings.current.duration = new Date().valueOf() - timings.current.start.valueOf();
            // Recording and tracking page load
            recordPageLoad(url, result, data, eventName, timerID);
        }
        else {
            // Recording page load but skip tracking until we get the FCP
            didAddTimmingBeforeFCP.current = true;
            timings.current.start = new Date();
            webVitals.current['page_load'] = {
                url: url,
                result: result,
                data: data,
                eventName: eventName
            };
            // Record metric but skip tracking until we have collected the required web vitals
            recordMetric(url, result, __assign(__assign({}, data), { skip: true }), eventName);
        }
    }, [recordPageLoad, recordMetric, customTimingLabel]);
    /**
     * Effect to react to Core Web Vital Metrics
     */
    (0, react_1.useEffect)(function () {
        if (!includeWebVitals)
            return;
        var subscription = PageVitalsObserver_1.ObserverFactory.getObserver(PageVitalsObserver_1.Events.WEB_VITALS).subscribe(function (metric) {
            var _a;
            if (includedWebVitals.includes(metric.name)) {
                // Store web vital metrics
                webVitals.current = __assign(__assign({}, webVitals.current), (_a = {}, _a[metric.name] = metric.value, _a));
                hasFCP.current = metric.name === 'FCP';
                if (hasFCP.current && hasTrackPageLoad.current && !hasRecordPageLoad.current) {
                    if (timings.current.start) {
                        timings.current.duration = new Date().valueOf() - timings.current.start.valueOf();
                    }
                    var data = webVitals.current['page_load'];
                    delete webVitals.current['page_load'];
                    recordPageLoad(data.url, data.result, __assign(__assign({}, data.data), { skip: false }), data.eventName, 'mainContent');
                }
                else if (hasFCP.current && !timings.current.start) {
                    timings.current.start = new Date();
                }
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recordPageLoad]);
    return trackPageLoad;
};
exports.default = useCoreWebvitals;
